import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFindHiredCandidatePositionStatusByCompanyQuery } from '../../../store/modules/candidates';
import EmptyState from '../../Positions/EmptyState/EmptyState';
import EmployeeCard from '../EmployeeCard/EmployeeCard';
import classes from './EmployeesList.module.css';
import Spinner from '../../Spinner/Spinner';

const EmployeesList: FC = () => {
  const [t, i18n] = useTranslation('global');
  const { data, isLoading } = useFindHiredCandidatePositionStatusByCompanyQuery(
    {
      lang: i18n.language as 'en' | 'es',
    }
  );

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
        }}
      >
        <Spinner />
      </div>
    );
  }

  // A hire whose candidate was deleted comes back with Candidate null; there is no one to show.
  const employees = data?.filter((position) => position.Candidate);

  if (employees && employees.length === 0) {
    return (
      <div className={classes.Container}>
        <EmptyState
          text={t('EmployeesPage.NoEmployeesText')}
          description={t('EmployeesPage.NoEmployeesDescription')}
        />
      </div>
    );
  }
  return (
    <div className="flex flex-col px-4 md:px-0 py-6">
      <div className="flex flex-row items-center pb-6">
        <h1 className="font-bold text-xl pr-4 text-nowrap">
          {t('EmployerDashboard.TeamMembers')}{' '}
        </h1>
        <div className="h-1 w-full border-b border-solid border-b-employer-secondary" />
      </div>
      <ul className="flex flex-row gap-6 justify-center flex-wrap">
        {employees?.map((position) => (
          <EmployeeCard
            key={position.Id}
            employee={position.Candidate}
            jobTitle={position.Position.JobPosition.title}
            acceptanceDate={new Date(position.acceptedTime)}
          />
        ))}
      </ul>
    </div>
  );
};

export default EmployeesList;
